// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sort-filter[data-v-f5aac0b2] {\n  background-color: transparent !important;\n}\n.sort-filter span[data-v-f5aac0b2] {\n  font-weight: 500;\n  color: var(--bluey-grey);\n  font-size: 0.93rem;\n}\n.active[data-v-f5aac0b2] {\n  color: var(--eggplant) !important;\n}\n", ""]);
// Exports
module.exports = exports;
